import React, { useEffect } from 'react';

import { resetAllSteps } from 'prequalificationV2/actions/stages';
import FormHeader from 'prequalificationV2/components/FormHeader';
import { useAppDispatch } from 'prequalificationV2/hooks/useAppDispatch';
import styles from 'prequalificationV2/pages/NotFound/NotFound.module.scss';
import { ProgressBarStatus } from 'enums/ProgressBarStatus';
import GeneralContactInfo from 'components/GeneralContactInfo';
import FormBody from 'components/FormBody';

const NotFoundContact = () => {
  const dispatch = useAppDispatch();

  useEffect(() => {
    return () => {
      dispatch(resetAllSteps());
    };
  });

  return (
    <>
      <FormHeader
        title="Something went wrong. Please try again later."
        subtitle="If you continue to experience problems, please contact HFS."
        percent={ProgressBarStatus.Warning}
      />
      <FormBody>
        <div className={styles.info_container}>
          <GeneralContactInfo />
        </div>
      </FormBody>
    </>
  );
};

export default NotFoundContact;
